// dependencies.
import { get } from 'lodash'
import URL_LOADING_PAGE_PROFESSIONAL from '@/plugins/http/url_professional'

const development = {
  countryregister: '',
  password: ''
}

const credentials = {
  type: 'company',
  countryregister: null,
  country_register: null,
  document: null,
  state: null,
  password: null,
  remember: true
}
const getCredentials = () => {
  if (get(process.env, 'NODE_ENV') === 'development') {
    return {...credentials, ...development}
  }

  return {...credentials}
}

export default () => ({
  URL_LOADING_PAGE_PROFESSIONAL: URL_LOADING_PAGE_PROFESSIONAL,
  loginFail: false,
  errors: {},
  credentials: getCredentials()
})



// WEBPACK FOOTER //
// ./src/app/auth/login/company/resources/data.js